let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ebL7h")).then(() => parcelRequire('8Tuck'));